import { Image, Platform, StyleSheet, Text, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useEffect } from "react";
import { globalStyles } from "../../styles/globalStyles";

export default function UsersRecommended({ reviews }) {
  let profilePictures = [];
  let recommenders = [];
  let index = 0;

  reviews.map((review) => {
    if (review.favorite) {
      if (review.reviewer.profilePicture == null)
        profilePictures.push({
          picture:
            "https://www.shutterstock.com/image-vector/default-avatar-profile-icon-social-600nw-1677509740.jpg",
          index: index,
        });
      else
        profilePictures.push({
          picture: review.reviewer.profilePicture,
          index: index,
        });
      recommenders.push(review.reviewer.userName);
      index++;
    }
  });
  return (
    <View style={{ alignItems: "center" }}>
      <View
        style={
          Platform.OS == "web"
            ? { ...styles.backgroundStyle, width: 500 }
            : styles.backgroundStyle
        }
      >
        <Text style={styles.text}>MEMBERS WHO RECOMMEND:</Text>
        {profilePictures.map((picture) => {
          if (picture.index < 3)
            return (
              <Image
                key={picture.index}
                source={{ uri: picture.picture, width: 40, height: 40 }}
                style={styles.imageStyle}
              />
            );
          else
            return (
              <View style={styles.plusStyle} key={picture.index}>
                <Text style={{ ...globalStyles.paragraph, color: "white" }}>
                  {"+".concat(profilePictures.length - 3)}
                </Text>
              </View>
            );
        })}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  backgroundStyle: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    height: 100,
    paddingVertical: 20,
    backgroundColor: "#a67960",
    marginHorizontal: 20,
    borderRadius: 30,
    opacity: 0.7,
    marginTop: 10,
    width: "90%",
    height: 70,
  },
  text: {
    fontFamily: "quicksand-bold",
    color: "white",
    fontSize: 17,
    marginRight: 25,
  },
  imageStyle: {
    borderRadius: 20,
    marginLeft: -15,
  },
  plusStyle: {
    width: 40,
    height: 40,
    backgroundColor: "#6e4732",
    borderRadius: 500,
    justifyContent: "center",
    alignItems: "center",
    marginLeft: -15,
  },
});
